import {
  openOldModalAction,
  stopLoaderThunk,
  startLoaderThunk,
  closeOldModalAction,
  setUnmountCallBackAction,
  onModalUnmountCallbackThunk,
} from './modalActions';
import { ModalState } from './modalTypes';
import { MODAL_NAMESPACE } from './modalReducer';
import { useAppAction, useAppSelector } from '../hooks';

export function useModalSelector<T extends (state: ModalState) => any>(
  selector: T
): ReturnType<T> {
  return useAppSelector((state) => selector(state[MODAL_NAMESPACE]));
}

export const useIsOldModalOpen = () =>
  useModalSelector((state) => {
    return state.isOldModalOpen;
  });

export const useModalComponentType = () =>
  useModalSelector((state) => {
    return state.component;
  });

export const useModalPosition = () =>
  useModalSelector((state) => {
    return state.position;
  });

export const useModalIsFullSizeOnMobile = () =>
  useModalSelector((state) => {
    return state.isFullSizeOnMobile;
  });

export const useIsLoaderActive = () =>
  useModalSelector((state) => {
    return state.isLoaderActive;
  });

export const useModalData = () =>
  useModalSelector((state) => {
    return state.oldModalData;
  });

export const useModalCancelCallback = () =>
  useModalSelector((state) => {
    return state.oldModalData?.cancelCallback;
  });

export const useModalUnmountCallback = () =>
  useModalSelector((state) => {
    return state?.onModalUnmountCallBack;
  });

export const useSetUnmountModalCallback = () =>
  useAppAction(setUnmountCallBackAction);
export const useModalUnmountCallbackThunk = () =>
  useAppAction(onModalUnmountCallbackThunk);
export const useOpenOldModal = () => useAppAction(openOldModalAction);
export const useCloseOldModal = () => useAppAction(closeOldModalAction);
export const useStartLoader = () => useAppAction(startLoaderThunk);
export const useStopLoader = () => useAppAction(stopLoaderThunk);
